<template>
  <div class>
    <button class="btn_blue" @click.prevent="show">
      Ny
    </button>
    <modal name="modal-create" :adaptive="true" height="auto" :scrollable="true" :width="450" @opened="opened">
      <div class="px-5 py-5">
        <h2 class="mb-4 text-xl tracking-wide">NY KLIENT</h2>

        <ValidationObserver ref="form" v-slot="{ invalid }">
          <form @submit.prevent="onCreate()">
            <span class="text-gray-700">Typ</span>
            <select v-model="client.clientType" class="block w-full mt-2 mb-5 form-select">
              <option value="0">
                SPA
              </option>
              <option value="3">
                Server till Server
              </option>
            </select>
            <ValidationProvider v-slot="{ errors }" name="Klient-Id" rules="required">
              <span class="text-gray-700">Klient-Id</span>
              <input v-model="client.clientId" type="text" class="w-full mt-1 form-input" :class="{
                  'border-red-600 focus:border-red-600': errors[0]
                }" />
              <span class="block mt-1 text-sm text-red-500">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" name="Klientnamn" rules="required">
              <span class="text-gray-700">Klientnamn</span>
              <input v-model="client.clientName" type="text" class="w-full mt-1 form-input" :class="{
                  'border-red-600 focus:border-red-600': errors[0]
                }" />
              <span class="block mt-1 text-sm text-red-500">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <div v-show="client.clientType == '3'">
              <span class="text-gray-700">Secret</span>
              <input v-model="client.secret" type="text" class="w-full mt-1 form-input" />
            </div>

            <div class="flex justify-end mt-10 mb-1">
              <button type="submit" class="block btn_blue" :class="{ 'opacity-50': invalid }" :disabled="invalid">Spara</button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      client: {
        clientId: "",
        clientName: "",
        clientType: 0,
        secret: ""
      }
    };
  },

  methods: {
    ...mapActions("clientsStore", ["add"]),
    show() {
      this.$modal.show("modal-create");
    },
    opened() {
      // this.cart.description = "";
      // this.$refs.description.focus();
    },
    // hide() {
    //   this.$modal.hide("modal-create");
    // },
    async onCreate() {
      await this.add(this.client);
      this.$modal.hide("modal-create");
    }
  }
};
</script>
